module.exports = __webpack_public_path__ + "central-relacionamento.357b8aa606f6a520805b.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/backgrounds/central-relacionamento.jpg
// module id = ../../../../../src/assets/images/backgrounds/central-relacionamento.jpg
// module chunks = styles